const messages = {
  title: "Marketing hozzájárulások",
  required: "Kötelező",
  answered: "✓ Megválaszolva",
  read: "Elolvasva",
  notRead: "Nincs elolvasva",
  alreadyAnswered: "Már megválaszolva",
  requiredQuestionsMustBeAccepted:
    "Még {count} kötelező kérdést kell elfogadni",
  pleaseAnswerQuestions: "Kérjük, válaszoljon a következő kérdésekre:",
  iAccept: "Elfogadom",
  scrollToUnlock: "A feloldáshoz görgessen a végére",
  fieldRequired: "Ez a mező kötelező",
  scrollToContinue: "↓ A folytatáshoz görgessen a végére",
  saving: "Mentés...",
  saveConsents: "Hozzájárulások mentése",
  allRequiredAccepted: "✓ Minden kötelező kérdés elfogadva",
  requiredConsentsCompleted:
    "{completed}/{total} kötelező hozzájárulás kitöltve",
  selectConsentToView:
    "Válasszon ki egy hozzájárulást a listából a tartalom megtekintéséhez",
  readAllContentFirst: "Először olvassa el a teljes tartalmat: {names}",
  acceptAllRequiredIn:
    "Fogadja el az összes kötelező kérdést itt: {names}",
  acceptAllBeforeSaving:
    "A mentés előtt fogadja el az összes kötelező kérdést.",
  failedToSave: "A hozzájárulások mentése sikertelen. Próbálja újra.",
  errorSaving:
    "Hiba történt a hozzájárulások mentésekor. Próbálja újra.",
  failedToLoad: "A hozzájárulások betöltése sikertelen. Frissítse az oldalt.",
  viewPdf: "PDF megtekintése",
  requiredConsentTitle: "Kötelező hozzájárulás",
  acceptAndContinue: "Elfogadás és folytatás",
};

export default {
  messages,
};
